import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  filterBar: {
    margin: '24px 0',
    width: '100%',
  },
  row: {
    display: 'flex',
  },
  col: {
    flex: 1,
    paddingRight: '8px',
  },
  clearButton: {
    display: 'flex',
    maxWidth: '32px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    margin: '24px 0',
    flexGrow: 1,
    '& .MuiInputBase-root': {
      height: '40px',
    },
  },
  iconButton: {
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
});

export default useStyles;
